import {
  CButton,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CSpinner,
} from '@coreui/react';
import { Plus, X, FileText, Check, Trash, Pencil } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { Upload } from 'lucide-react';
import PatientReportCRUD from '../../services/general/patientReportCrud.api';
import CloudinaryUploader from '../../components/shared/CloudinaryUploader';
import PatientPastNote from './PatientPastNote';

const Reports = ({ patientID, viewPatientDetail, patientTreatments, noteID, showAllNotes = false }) => {
  const threeSections = ['Labs', 'Medication', 'Imaging', 'Miscellaneous'];
  const [visible, setVisible] = useState(false);
  const [modeReport, setModeReport] = useState('');
  const [fileBase64, setFileBase64] = useState('');
  const [viewer, setViewer] = useState(false);
  const [selectedFileViewBase64, setSelectedFileViewBase64] = useState('');
  const [reportData, setReportData] = useState({
    Labs: [],
    Medication: [],
    Imaging: [],
    Miscellaneous: [],
  });
  const [file, setFile] = useState([]);
  const [isPageLoading, setIsPageLoading] = useState(false);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFileBase64(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const toggleModal = (mode) => {
    // if (visible) {
    //   setVisible(false);
    //   setModeReport('');
    //   setFileBase64('');
    // } else {
    //   setVisible(true);
    //   setModeReport(mode);
    // }
    setModeReport(mode);
  };

  const getFormattedDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    const hh = String(today.getHours()).padStart(2, '0');
    const min = String(today.getMinutes()).padStart(2, '0');
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`;
  };

  const fetchReports = async () => {
    setIsPageLoading(true);
    for (const sections of threeSections) {
      let formattedData;
      formattedData = await PatientReportCRUD(
        'GET',
        patientID.toString(),
        '',
        sections.toString()
      );

      if (formattedData) {
        formattedData = JSON.parse(formattedData.d)?.Data;
        formattedData = formattedData.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          };
        });
      }

      console.log(formattedData, 'formattedData')
      setReportData((p) => ({
        ...p,
        [sections]: formattedData,
      }));
    }
    setIsPageLoading(false);
  };

  useEffect(() => {
    fetchReports();
  }, []);

  console.log(reportData, 'reportData');
  const handleSubmit = async (mediaData) => {
    const jsonFormat = JSON.stringify(mediaData);

    await PatientReportCRUD(
      'INSERT',
      patientID.toString(),
      '',
      modeReport.toString(),
      jsonFormat,
      getFormattedDate().toString()
    );
    setModeReport('');
    setFileBase64('');
    // setFile([]);

    setVisible(false);
    await fetchReports();
  };


  const handleDeleteFileData = async (id) => {
    await PatientReportCRUD(
      'DELETE',
      patientID.toString(),
      id
    );
    await fetchReports();

  }
  const handleViewFile = (file) => {
    setSelectedFileViewBase64(file);
    setViewer(true);
  };

  const handleDeleteFile = (id) => {

    setFile(prevFiles => {
      if (prevFiles.length === 1) return [];
      return prevFiles.filter((item, i) => item.id !== id);
    });

  };


  const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {

    setFile(prevFiles => {
      const isDuplicate = prevFiles.some(file => file.url === url);
      if (isDuplicate) return prevFiles;
      handleSubmit([{ url, type, fileName, id, publicId }]);
      return [...prevFiles, { url, type, fileName, id, publicId }];
    });
    // setTimeout(()=>(handleSubmit,2000))

  };


  const userData = JSON.parse(localStorage.getItem('user'))

  const role = userData?.Role


  return (
    <>
      <div className='d-flex align-items-start gap-4 flex-column'>
        {Object.entries(reportData).map(([key, data], i) => {

          return (
            <div className="pb-12" key={i}>
              <h6 className={`${role === 'provider' ? 'text-white' : ''} p-0`} style={{ fontSize: '16px', marginBottom: '10px' }}>{key}</h6>
              <div className="d-flex align-items-start flex-wrap gap-3 mt-3">
                {isPageLoading ? (
                  <CSpinner className="mt-3" />
                ) : (
                  <>
                    {/* Upload Button */}
                    <div
                      onClick={() => toggleModal(key)}
                      className="d-flex align-items-center justify-content-center cursor-pointer"
                      style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '12px',
                        backgroundColor: role === 'provider' ? '#191919' : 'white',
                      }}
                    >
                      {console.log('data data ', data)}
                      <CloudinaryUploader
                        // filesAl={data || [] }
                        onDelete={handleDeleteFile}
                        onUploadSuccess={handleCloudinaryUpload}
                        showStyleButton={true}
                      />
                    </div>

                    <div className="d-flex align-items-center flex-wrap gap-2  ">
                      {data?.map((entry, idx) => (
                        <div key={idx} className="">
                          <div className="d-flex flex-wrap gap-3">
                            {entry.data?.map((file, fileIdx) => {
                              const fileUrl = file.uploaded ? file.url : file.preview || file.url
                              const fileType = file.type || ''
                              const extension = fileUrl.split('.').pop().toLowerCase()

                              return (
                                <div key={fileIdx} className="d-flex flex-column align-items-center text-center">
                                  {fileType === 'image' ? (
                                    <div
                                      style={{
                                        position: 'relative',
                                        width: '80px',
                                        height: '80px',
                                        borderRadius: '4px',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                      }}
                                      className="shadow border"
                                      onClick={() => window.open(fileUrl, '_blank', 'noopener,noreferrer')}
                                      role="button"
                                      tabIndex={0}
                                    >
                                      <img
                                        src={fileUrl}
                                        alt={file.fileName || 'Preview'}
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          objectFit: 'cover',
                                        }}
                                      />

                                      <div
                                        style={{
                                          position: 'absolute',
                                          top: '4px',
                                          right: '4px',
                                          display: 'flex',
                                          gap: '6px',
                                          backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                          borderRadius: '4px',
                                          padding: '2px',
                                        }}
                                      >
                                        {/* <Pencil
                                        className="cursor-pointer text-primary"
                                        size={15}
                                        onClick={() => handleEditFileData(entry.id)}
                                      /> */}
                                        <Trash className="cursor-pointer text-danger" size={15} onClick={() => handleDeleteFileData(entry.id)} style={{ cursor: 'pointer' }} />
                                      </div>
                                    </div>
                                  ) : fileType === 'video' || ['mp4', 'webm', 'ogg'].includes(extension) ? (
                                    <div
                                      style={{
                                        position: 'relative',
                                        width: '80px',
                                        height: '80px',
                                        borderRadius: '4px',
                                        overflow: 'hidden',
                                        pointer: 'cursor',
                                      }}
                                      className="shadow border"
                                    >
                                      {/* Video */}
                                      <video
                                        src={fileUrl}
                                        controls
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          objectFit: 'cover',
                                        }}
                                      />

                                      {/* Action buttons */}
                                      <div
                                        style={{
                                          position: 'absolute',
                                          top: '4px',
                                          right: '4px',
                                          display: 'flex',
                                          gap: '6px',
                                          backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                          borderRadius: '4px',
                                          padding: '2px',
                                        }}
                                      >
                                        {/* <Pencil
                                          className="cursor-pointer text-primary"
                                          size={15}
                                          onClick={() => handleEditFileData(entry.id)}
                                        /> */}
                                        <Trash className="cursor-pointer text-danger" size={15} onClick={() => handleDeleteFileData(entry.id)} style={{ cursor: 'pointer' }} />
                                      </div>
                                    </div>
                                  ) : ['pdf', 'doc', 'docx'].includes(extension) ? (
                                    <div
                                      style={{
                                        position: 'relative',
                                        width: '80px',
                                        height: '80px',
                                        borderRadius: '4px',
                                        overflow: 'hidden',
                                        background: '#f8f9fa',
                                      }}
                                      className="d-flex align-items-center justify-content-center border shadow"
                                    >
                                      {/* File Icon & Extension */}
                                      <a
                                        href={fileUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          textDecoration: 'none',
                                          color: 'inherit',
                                        }}
                                        className="d-flex align-items-center justify-content-center flex-column"
                                      >
                                        <i className="bi bi-file-earmark-text" style={{ fontSize: '24px' }}></i>
                                        <p className="small m-0">{extension.toUpperCase()}</p>
                                      </a>

                                      {/* Action buttons */}
                                      <div
                                        style={{
                                          position: 'absolute',
                                          top: '4px',
                                          right: '4px',
                                          display: 'flex',
                                          gap: '6px',
                                          backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                          borderRadius: '4px',
                                          padding: '2px',
                                        }}
                                      >
                                        {/* <Pencil
                                            className="cursor-pointer text-primary"
                                            size={15}
                                            onClick={() => handleEditFileData(entry.id)}
                                          /> */}
                                        <Trash className="cursor-pointer text-danger" size={15} onClick={() => handleDeleteFileData(entry.id)} style={{ cursor: 'delete' }} />
                                      </div>
                                    </div>
                                  ) : (
                                    <a
                                      href={fileUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        width: '100px',
                                        height: '100px',
                                        borderRadius: '4px',
                                        background: '#e0e0e0',
                                      }}
                                      className="d-flex align-items-center justify-content-center border"
                                    >
                                      <div>
                                        <i className="bi bi-file-earmark" style={{ fontSize: '24px' }}></i>
                                        <p className="small m-0">File</p>
                                      </div>
                                    </a>
                                  )}
                                  <small className="mt-1 text-truncate" style={{ maxWidth: '100px' }}>
                                    {file.fileName}
                                  </small>
                                </div>
                              )
                            })}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          )
        })}

        {showAllNotes && <div className='w-full'>
          <div className='p-0 mb-16 '>
            <h6 className='text-white' style={{ fontSize: '16px', marginBottom: '10px' }}>Notes</h6>
          </div>
          <div  >
            <PatientPastNote viewPatientDetail={viewPatientDetail} patientTreatments={patientTreatments} noteID={noteID} providerCall={true} />
          </div>
        </div>}

      </div>


      <CModal size='md' backdrop={'static'} visible={visible} onClose={() => {
        setVisible(false);
        setModeReport('');
        setFileBase64('');
      }}>
        <CModalHeader>
          <CModalTitle>Upload and Preview File</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {/* <div className='mb-3'>
              <CFormLabel
                className='w-full gap-2 d-flex align-items-center justify-content-center flex-column bg-light rounded'
                style={{ height: '200px', background: 'rgb(233 236 252)' }}
                htmlFor='formFile'
              >
                <Upload size={20} />
                <p className='font-weight-bold'>Choose Image or PDF</p>
                <p
                  style={{ fontSize: '14px' }}
                  className='font-weight-bold p-0 m-0'
                >
                  We accept JPG, PNG, & PDF formats
                </p>
              </CFormLabel>
              <CFormInput
                accept='image/*,application/pdf'
                type='file'
                id='formFile'
                className='hidden'
                onChange={handleFileUpload}
                label='Default file input example'
              />
            </div>
            {fileBase64 && (
              <div
                className='mt-3 shadow rounded'
                style={{
                  width: '80px',
                  height: '80px',
                  overflow: 'hidden',
                }}
              >
                {fileBase64.startsWith('data:image') ? (
                  <img
                    src={fileBase64}
                    alt='Uploaded'
                    className='object-fit-cover w-100 h-100'
                  />
                ) : (
                  <div className='d-flex align-items-center justify-content-center h-100'>
                    <FileText/>
                  </div>
                )}
              </div>
            )} */}

          <CloudinaryUploader
            // filesAl={editEducations ? editEducations?.file : file}
            onDelete={handleDeleteFile}
            onUploadSuccess={handleCloudinaryUpload}
            showStyleButton={true}
          />
        </CModalBody>
        <CModalFooter className='d-flex p-3 border-top m-0'>
          <CButton
            color='secondary'
            onClick={() => {
              setVisible(false);
              setModeReport('');
              setFileBase64('');
            }}
          >
            Close
          </CButton>
          <CButton onClick={handleSubmit} color='primary'>
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>

      {viewer && (
        <div
          style={{
            height: '100vh',
            position: 'fixed',
            background: 'rgb(39 39 39 / 58%)',
            top: 0,
            left: 0,
            zIndex: '100000000',
          }}
          className='position-fixed d-flex align-items-center justify-content-center top-0 left-0 z-50 w-100'
        >
          <div style={{ width: '100%', height: '100%', overflow: "auto" }}>
            <X
              onClick={() => {
                setViewer(false);
                setSelectedFileViewBase64('');
              }}
              size={30}
              strokeWidth={1}
              className='bg-white rounded-circle text-black'
              style={{
                position: 'absolute',
                right: '10px',
                top: '10px',
              }}
            />
            {selectedFileViewBase64.startsWith('data:image') ? (
              <img
                src={selectedFileViewBase64}
                className='w-full h-full object-fit-cover'
                alt=''
              />
            ) : (
              <iframe
                src={selectedFileViewBase64}
                title='PDF Preview'
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                }}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Reports;
